<template>
  <div>
    <resend-webhooks-confirmation v-if="getterPopupName === 'ResendWebhooksConfirmation'"
                :webhookOptions="paginate" @resendWebhooks="$emit('resendWebhooks')" />

    <md-field id="Actions">
      <md-select placeholder="Actions" @md-opened="setDropdownPosOffset('Actions')"
                v-model="actions" :ref="'Actions'">
        <md-option value="Resend Webhooks">Resend Webhooks <span v-if="paginate.total">({{paginate.total}})</span></md-option>
      </md-select>
    </md-field>
  </div>
</template>

<script>
import ResendWebhooksConfirmation from '@/components/global/ResendWebhooksConfirmation'

import { setDropdownPosOffset, openPopup } from '@/utils/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'BulkResendWebhooks',
  components: { ResendWebhooksConfirmation },
  data () {
    return {
      actions: null
    }
  },
  props: {
    paginate: Object
  },
  watch: {
    actions (newVal) {
      if (newVal === 'Resend Webhooks') {
        this.openPopup('ResendWebhooksConfirmation')
        this.$refs.Actions.clearField()
      }
    }
  },
  computed: {
    ...mapGetters(['getterPopupName'])
  },
  methods: {
    setDropdownPosOffset,
    openPopup
  }
}
</script>

<style lang="scss" scoped>
  .desktop {
    #Actions {
      margin: 0 10px !important;
      min-width: 200px;
    }
  }

  .mobile, .tablet {
    #Actions {
      margin: 10px auto 0 !important;
      text-align: right;
    }
  }
</style>
